import { singletonFactory } from '@warehouse/shared/util';
import { LocalStorageRepository } from './local-storage.repository';
import { LocalStorageRepositoryImpl } from './local-storage.repository.impl';

export const localStorageRepositorySingleton = singletonFactory<LocalStorageRepository>({
	factory: () => new LocalStorageRepositoryImpl(),
});
